import { isDefined } from '@sgme/fp';

import { useTrackEvent } from '@/App/Blotter/useTrackEvent.ts';
import { useAlgoTileId, useValidateAlgo } from '@/App/tiles/orders/AlgoOrders/AlgoContext.tsx';
import { OrderRow } from '@/App/tiles/orders/components/OrderRow.tsx';
import { OmsFieldErrorWrapper } from '@/components/ui/OmsFieldErrorWrapper.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import {
  selectAlgoErrors,
  selectOrderEntryByIdFromBlotter,
  selectTradeIdFromAlgoTile,
} from '@/store/orders/algoOrders/selectors.ts';

type AlgoAlphaSeekerProps = {
  alphaSeeker: boolean | undefined;
  setAlphaSeeker: (value: boolean | undefined) => void;
};

export const AlgoEditingAlphaSeeker = ({ alphaSeeker, setAlphaSeeker }: AlgoAlphaSeekerProps) => {
  const tileId = useAlgoTileId();
  const track = useTrackEvent();

  const tradeId = useAppSelector((state) => selectTradeIdFromAlgoTile(state, tileId));
  const orderFromBlotter = useAppSelector((state) =>
    tradeId ? selectOrderEntryByIdFromBlotter(state, tradeId) : undefined,
  );
  const value = alphaSeeker ?? (isDefined(orderFromBlotter?.alphaSeeker) ? orderFromBlotter?.alphaSeeker : undefined);
  const errors = useAppSelector((state) => selectAlgoErrors(state, tileId));

  const validateAlgo = useValidateAlgo();

  const handleAlphaSeekerChange = async (newValue: boolean) => {
    track('Order action', 'Alpha seeker changed');
    const response = await validateAlgo({
      alphaSeeker: newValue,
    });

    if (response?.data?.validationResponseDetailContent.length === 0) {
      setAlphaSeeker(newValue);
    }
  };

  const alphaSeekerError = errors?.alphaSeeker;

  return (
    <OrderRow labelId="order.fields.alphaSeeker">
      <OmsFieldErrorWrapper errors={alphaSeekerError}>
        <div className="form-check form-check-sm">
          <input
            id="alphaSeeker"
            className="form-check-input me-8px"
            type="checkbox"
            checked={value}
            onChange={(e) => handleAlphaSeekerChange(e.target.checked)}
            data-e2e="alphaSeeker-checkbox"
          />
        </div>
      </OmsFieldErrorWrapper>
    </OrderRow>
  );
};
